<template>
  <div>
    <svg
      width="121px"
      height="121px"
      viewBox="0 0 176 176"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Rijnja regelt het</title>
      <defs>
        <polygon
          id="path-1-rrr"
          points="0 0.889 175.1107 0.889 175.1107 175.9999 0 175.9999"
        ></polygon>
        <polygon
          id="path-3-rrr"
          points="0 176.111 175.111 176.111 175.111 1 0 1"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g transform="translate(0.000000, -1.000000)">
          <g id="Group-3" transform="translate(0.000000, 0.111000)">
            <mask id="mask-2" fill="white">
              <use xlink:href="#path-1-rrr"></use>
            </mask>
            <g id="Clip-2"></g>
            <path
              d="M175.1107,88.4449 C175.1107,136.7999 135.9107,175.9999 87.5557,175.9999 C39.1997,175.9999 -0.0003,136.7999 -0.0003,88.4449 C-0.0003,40.0899 39.1997,0.8889 87.5557,0.8889 C135.9107,0.8889 175.1107,40.0899 175.1107,88.4449"
              id="Fill-1"
              fill="#EA0029"
              mask="url(#mask-2)"
              :style="{ fill: color }"
            ></path>
          </g>
          <path
            d="M37.0824,55.9582 L40.1754,55.9582 C42.0914,55.9582 44.5784,55.8912 44.5784,53.3022 C44.5784,50.9162 42.4274,50.5462 40.5114,50.5462 L37.0824,50.5462 L37.0824,55.9582 Z M31.8384,46.1092 L41.0494,46.1092 C45.9224,46.1092 50.0244,47.7902 50.0244,53.3362 C50.0244,56.6642 48.2424,59.2522 44.8814,59.8572 L50.9314,69.9072 L44.6464,69.9072 L39.6714,60.3952 L37.0824,60.3952 L37.0824,69.9072 L31.8384,69.9072 L31.8384,46.1092 Z"
            id="Fill-4"
            fill="#FEFEFE"
          ></path>
          <mask id="mask-4" fill="white">
            <use xlink:href="#path-3-rrr"></use>
          </mask>
          <g id="Clip-7"></g>
          <polygon
            id="Fill-6"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="53.556 69.908 58.8 69.908 58.8 46.11 53.556 46.11"
          ></polygon>
          <path
            d="M75.4984,61.9412 C75.4984,66.3442 74.3564,70.5122 67.9024,70.5122 C64.1374,70.5122 61.3814,68.7652 60.6084,64.9662 L65.4154,63.7902 C65.5494,64.9332 66.6244,65.8742 67.7684,65.8742 C70.2214,65.8742 70.2554,63.1512 70.2554,61.3702 L70.2554,46.1092 L75.4984,46.1092 L75.4984,61.9412 Z"
            id="Fill-8"
            fill="#FEFEFE"
            mask="url(#mask-4)"
          ></path>
          <polygon
            id="Fill-9"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="80.3826 46.1096 87.5086 46.1096 97.6266 62.6466 97.6936 62.6466 97.6936 46.1096 102.9376 46.1096 102.9376 69.9076 96.0806 69.9076 85.6946 52.9666 85.6266 52.9666 85.6266 69.9076 80.3826 69.9076"
          ></polygon>
          <path
            d="M120.0081,61.9412 C120.0081,66.3442 118.8651,70.5122 112.4121,70.5122 C108.6471,70.5122 105.8901,68.7652 105.1181,64.9662 L109.9251,63.7902 C110.0591,64.9332 111.1341,65.8742 112.2781,65.8742 C114.7311,65.8742 114.7651,63.1512 114.7651,61.3702 L114.7651,46.1092 L120.0081,46.1092 L120.0081,61.9412 Z"
            id="Fill-10"
            fill="#FEFEFE"
            mask="url(#mask-4)"
          ></path>
          <path
            d="M134.4393,53.0339 L131.5483,60.4289 L137.3633,60.4289 L134.4393,53.0339 Z M132.4223,46.1099 L136.7583,46.1099 L147.1113,69.9079 L141.1943,69.9079 L139.1443,64.8659 L129.9013,64.8659 L127.9183,69.9079 L122.1363,69.9079 L132.4223,46.1099 Z"
            id="Fill-11"
            fill="#FEFEFE"
            mask="url(#mask-4)"
          ></path>
          <path
            d="M33.6375,88.5955 L36.7305,88.5955 C38.6455,88.5955 41.1335,88.5275 41.1335,85.9395 C41.1335,83.5535 38.9825,83.1835 37.0665,83.1835 L33.6375,83.1835 L33.6375,88.5955 Z M28.3935,78.7465 L37.6045,78.7465 C42.4775,78.7465 46.5795,80.4275 46.5795,85.9735 C46.5795,89.3015 44.7975,91.8895 41.4365,92.4945 L47.4865,102.5445 L41.2005,102.5445 L36.2255,93.0325 L33.6375,93.0325 L33.6375,102.5445 L28.3935,102.5445 L28.3935,78.7465 Z"
            id="Fill-12"
            fill="#FEFEFE"
            mask="url(#mask-4)"
          ></path>
          <polygon
            id="Fill-13"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="50.494 78.7468 66.661 78.7468 66.661 83.5868 55.738 83.5868 55.738 88.0238 66.057 88.0238 66.057 92.8638 55.738 92.8638 55.738 97.7048 67.266 97.7048 67.266 102.5448 50.494 102.5448"
          ></polygon>
          <path
            d="M92.9032,100.864 C89.8112,102.477 86.4162,103.15 82.9212,103.15 C75.4922,103.15 70.0802,98.276 70.0802,90.646 C70.0802,83.015 75.4922,78.142 82.9212,78.142 C86.6852,78.142 90.0132,78.982 92.3992,81.2 L88.7022,85.234 C87.2902,83.755 85.5762,82.982 82.9212,82.982 C78.4492,82.982 75.5262,86.209 75.5262,90.646 C75.5262,95.082 78.4492,98.309 82.9212,98.309 C85.2062,98.309 86.8872,97.671 87.8612,97.133 L87.8612,93.267 L83.5922,93.267 L83.5922,88.427 L92.9032,88.427 L92.9032,100.864 Z"
            id="Fill-14"
            fill="#FEFEFE"
            mask="url(#mask-4)"
          ></path>
          <polygon
            id="Fill-15"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="97.827 78.7468 113.994 78.7468 113.994 83.5868 103.071 83.5868 103.071 88.0238 113.39 88.0238 113.39 92.8638 103.071 92.8638 103.071 97.7048 114.6 97.7048 114.6 102.5448 97.827 102.5448"
          ></polygon>
          <polygon
            id="Fill-16"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="119.0814 78.7468 124.3254 78.7468 124.3254 97.7048 134.0394 97.7048 134.0394 102.5448 119.0814 102.5448"
          ></polygon>
          <polygon
            id="Fill-17"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="138.2547 83.385 131.4647 83.385 131.4647 78.747 150.2887 78.747 150.2887 83.385 143.4987 83.385 143.4987 102.545 138.2547 102.545"
          ></polygon>
          <polygon
            id="Fill-18"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="57.3348 111.384 62.5788 111.384 62.5788 120.258 72.7628 120.258 72.7628 111.384 78.0068 111.384 78.0068 135.182 72.7628 135.182 72.7628 124.897 62.5788 124.897 62.5788 135.182 57.3348 135.182"
          ></polygon>
          <polygon
            id="Fill-19"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="83.3924 111.384 99.5594 111.384 99.5594 116.224 88.6364 116.224 88.6364 120.661 98.9554 120.661 98.9554 125.502 88.6364 125.502 88.6364 130.342 100.1644 130.342 100.1644 135.182 83.3924 135.182"
          ></polygon>
          <polygon
            id="Fill-20"
            fill="#FEFEFE"
            mask="url(#mask-4)"
            points="108.9749 116.0227 102.1849 116.0227 102.1849 111.3837 121.0079 111.3837 121.0079 116.0227 114.2179 116.0227 114.2179 135.1817 108.9749 135.1817"
          ></polygon>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: ['color']
}
</script>

<style lang="scss" scoped></style>
